import "../helpers";
import axios from "axios";
import "../router";
import { users } from "../helpers";

export const userService = {
  login,
  logout,
  validate
};

function validate(data) {
    // set the authentication header
    return axios
        .post(process.env.VUE_APP_AP_API + 'validate/', data)
        .then(result => {
            return result;
        });
}

function login(username, password, userType) {
  let authUrl = "";

  if (userType == users.ap) authUrl = process.env.VUE_APP_AP_AUTH;
  else if (userType == users.ins) authUrl = process.env.VUE_APP_INS_AUTH;

  return axios
    .post(authUrl, { username, password })
    .then(handleResponse)
    .then(res => {
      sessionStorage.setItem("token", res.data.token);
      return res.data.token;
    });
}

function logout() {
  // remove user from local storage to log user out
  sessionStorage.removeItem("token");
}

function handleResponse(response) {
  if (!(response.status === 200)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      logout();
      location.reload(true);
    }
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response;
}
